export default __webpack_public_path__ + "static/media/CNo.79-0.9cb2e4f3.jpg";